import { Box, makeStyles, styled } from "@material-ui/core";
import { memo } from "react";
import {
  EPOCUS_SYNCED_TEXT,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";
import { CheckIcon } from "./icons";

const Root = styled(Box)({ textAlign: "center", padding: "8px 0" });

const Burst = styled(Box)({
  width: 52,
  height: 52,
  margin: "0 auto 10px",
  position: "relative",
});

const Title = styled("p")({
  fontWeight: 700,
  fontSize: rem(17),
  color: EPOCUS_TEXT_PRIMARY,
  margin: "0 0 3px",
});

const Detail = styled("p")({
  fontSize: rem(12),
  color: EPOCUS_TEXT_SECONDARY,
  margin: 0,
});

// MUI v4 `styled()` compiles a single rule; a nested @keyframes throws in JSS.
const useBurstStyles = makeStyles({
  "@keyframes ripple": {
    "0%": { transform: "scale(.5)", opacity: 0.8 },
    "100%": { transform: "scale(1.4)", opacity: 0 },
  },
  "@keyframes pop": {
    "0%": { transform: "scale(0)" },
    "100%": { transform: "scale(1)" },
  },
  ring: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    border: `2px solid ${EPOCUS_SYNCED_TEXT}`,
    animation: "$ripple 1.6s ease-out infinite",
    "&:nth-child(2)": { animationDelay: ".5s" },
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  },
  core: {
    position: "absolute",
    inset: 13,
    borderRadius: "50%",
    backgroundColor: EPOCUS_SYNCED_TEXT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: EPOCUS_WHITE,
    animation: "$pop .5s cubic-bezier(.3,1.4,.5,1)",
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  },
});

export const Milestone = memo<{ title: string; detail?: string }>(
  ({ title, detail }) => {
    const classes = useBurstStyles();
    return (
      <Root role="status">
        <Burst aria-hidden>
          <div className={classes.ring} />
          <div className={classes.ring} />
          <div className={classes.core}>
            <CheckIcon size={16} />
          </div>
        </Burst>
        <Title>{title}</Title>
        {detail && <Detail>{detail}</Detail>}
      </Root>
    );
  },
);
Milestone.displayName = "Milestone";
